module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-3rd@3x-073d9c8fc840a2595bbacbf0a63b1419.png";